import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";

/**
 * Lightweight "Coming Soon" modal shown when a visitor clicks the Subscribe pill.
 * Everything that matters sits in this component so the trigger stays dumb.
 */
export default function SubscribeModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md border border-[#E2DDD3] p-0 overflow-hidden"
        style={{ background: "#F7F4EE" }}
        data-testid="subscribe-coming-soon-modal"
      >
        <div className="p-7 text-center">
          <div className="w-12 h-12 mx-auto rounded-full flex items-center justify-center mb-4"
               style={{ background: "rgba(217,30,42,0.1)" }}>
            <Sparkles className="w-5 h-5 text-[#D91E2A]" />
          </div>
          <div className="ns-eyebrow mb-2" style={{ fontSize: 11 }}>Nivesh Street Premium</div>
          <h2 className="font-heading text-3xl font-extrabold text-[#1A1A1A] leading-tight mb-2">
            Coming Soon
          </h2>
          <p className="text-sm text-[#6B6C6F] leading-relaxed">
            We're building a premium subscriber briefing with DRHP deep-dives, GMP alerts and the
            Street's weekly playbook. Save your seat on the waitlist from the home page footer.
          </p>
          <button
            onClick={() => onOpenChange?.(false)}
            className="mt-6 px-5 py-2.5 rounded-full bg-[#D91E2A] text-white text-sm font-semibold hover:bg-[#B8141F]"
            data-testid="subscribe-modal-dismiss"
          >
            Got it
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
